export default __webpack_public_path__ + "static/media/p.572892f9.svg";